import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { PickForMeFab } from "@/pages/LearningHub";

/**
 * Global mount of the Odyssey Smart Bot orb.
 *
 * Mounted once inside <Layout/> so the friendly mascot floats on every
 * authenticated page (Dashboard, Calendar, Org, Attendance, KNO, Control
 * Panel, etc.) — NOT just /learning.
 *
 * The orb itself no longer requires a catalog probe: a flaky network call
 * used to hide it permanently for some accounts. The pick modal handles
 * empty-catalog states internally instead.
 */
const GlobalSmartBot = () => {
    const location = useLocation();
    const navigate = useNavigate();

    // /learning already renders its own copy of the Fab; skip the global
    // one there to avoid two orbs stacking on the same screen.
    if (location.pathname.startsWith("/learning")) return null;

    return (
        <PickForMeFab
            catalogReady={true}
            onOpenResource={(pick) => {
                // Deep-link into the parent collection's detail dialog.
                if (pick?.collection_id) {
                    navigate(`/learning?collection=${pick.collection_id}`);
                } else {
                    navigate("/learning");
                }
            }}
        />
    );
};

export default GlobalSmartBot;
